import { unwrapFieldValue } from 'features/libra/ontology/ontologyFieldDefaults'
import {
  FieldValues,
  OntologyField,
} from 'features/libra/ontology/ontologyFieldTypes'
import {
  buildComputedReportRows,
  formatReportFieldValue,
} from 'features/libra/pdf/reportFieldFormatting'
import { Section } from 'features/libra/sections/sectionTypes'

import { WorkPackSection } from './workPackTypes'

export function buildWorkPackFormSections(
  sections: Section[],
  definitions: Record<string, OntologyField>,
  fields: FieldValues
): WorkPackSection[] {
  return sections.flatMap((section) => {
    if (section.type === 'form')
      return [
        {
          title: section.title ?? section.id,
          rows: section.fields.map((field) => {
            const raw = unwrapFieldValue(fields[field])
            return {
              label: definitions[field]?.name ?? field,
              value:
                raw === undefined || raw === null || raw === ''
                  ? 'Not recorded'
                  : formatReportFieldValue(raw, definitions[field]),
            }
          }),
        },
      ]
    if (section.type !== 'computed') return []
    const rows = buildComputedReportRows(section, definitions, fields)
    return rows.length ? [{ title: section.title ?? section.id, rows }] : []
  })
}
